module.exports = __webpack_public_path__ + "img/quickbooks.3e077705.png";